import { render, staticRenderFns } from "./RadishLike.vue?vue&type=template&id=7b24ba22&scoped=true&"
import script from "./RadishLike.vue?vue&type=script&lang=js&"
export * from "./RadishLike.vue?vue&type=script&lang=js&"
import style0 from "./RadishLike.vue?vue&type=style&index=0&id=7b24ba22&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=7b24ba22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b24ba22",
  null
  
)

export default component.exports